module.exports = __webpack_public_path__ + "img/2.0be7c852.jpg";